module.exports = __webpack_public_path__ + "static/media/spicyoctopus.20b50c36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicyoctopus.jpg
// module id = 110
// module chunks = 0